import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=c8d0aed6&scoped=true"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=c8d0aed6&prod&scoped=true&lang=css"
import style1 from "./GlobalSettings.vue?vue&type=style&index=1&id=c8d0aed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d0aed6",
  null
  
)

export default component.exports